const defaultPageSize = 10

function savePageSize(storageId, size) {
  this.$ls.set(storageId, size)
}

function getPageSize(storageId) {
  return +this.$ls.get(storageId, defaultPageSize)
}

export { savePageSize, getPageSize }
